import styled from '@emotion/styled/macro';
import {
    BaseButton,
    forPhoneOnly,
    forTabletLandscapeDown,
    LayoutRow,
    ResponsibilityBadge,
    Variables,
} from '@enter/core';
import { Icon } from '@mdi/react';
import { AlertBar, PageLayoutRow } from 'components';

export const StyledPageLayoutRow = styled(PageLayoutRow)`
    margin-top: 0;
    margin-bottom: 24px;
    flex-wrap: nowrap;
`;

export const LinkButton = styled(BaseButton)`
    padding: 0;
    min-width: 40px;
    margin-left: 4px;
    padding: 5px;
`;

export const Loader = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 1 40%;
    justify-content: center;

    & > svg {
        background-color: transparent;
    }
`;